import { FieldArray } from 'react-final-form-arrays';
import { Grid, Box } from '@mui/material';

import { IconButton, Typography, AddIcon, DeleteIcon } from '@occc/ui-design-system';
import {
  TextField,
  Radios,
  CurrencyInputField,
  ProductGroupSelectField,
  Select,
} from '@occc-app/design-system';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

const selectData = [
  { label: 'Money Amount', value: Earning_Mechanism_Product_Counting_Attribute.MoneyAmount },
  { label: 'Quantity', value: Earning_Mechanism_Product_Counting_Attribute.Quantity },
  { label: 'Selling Unit', value: Earning_Mechanism_Product_Counting_Attribute.UnitsCount },
];

const radioData = [
  { label: 'Per Transaction', value: 'varietyPurchase' },
  { label: 'Over Time', value: 'varietyPurchaseOverTime' },
];

export const ProductChallengeConfiguration = () => {
  const { isEditable } = useCanEditFormFieldsContext();

  return (
    <Box mt={2}>
      <Typography variant='subtitle1' paragraph>
        When They Purchase
      </Typography>
      <FieldArray name='productChallenge.products'>
        {({ fields }) => {
          const handleAddItem = () => {
            fields.push({ countProductsBy: Earning_Mechanism_Product_Counting_Attribute.Quantity });
          };
          return (
            <>
              {fields.map((fieldArrayName, index) => {
                const countByValue = fields.value[index].countProductsBy;
                const thresholdName = `${fieldArrayName}.purchaseThreshold`;
                const thresholdLabel = 'Threshold';
                const isCountByItems =
                  countByValue === Earning_Mechanism_Product_Counting_Attribute.Quantity ||
                  countByValue === Earning_Mechanism_Product_Counting_Attribute.UnitsCount;

                const isAddActionShown = index === (fields.length || 1) - 1 && isEditable;
                const isDeleteActionShown = isEditable && (fields.length ?? 0) > 1;

                const handleRemoveItem = () => {
                  fields.remove(index);
                };

                const handleSelectChange = () => {
                  fields.update(index, { ...fields.value[index], purchaseThreshold: undefined });
                };

                return (
                  <div key={fieldArrayName}>
                    <Box mb={2}>
                      <Grid container spacing={2}>
                        <Grid item sm={2}>
                          {isCountByItems && (
                            <TextField
                              name={thresholdName}
                              label={thresholdLabel}
                              type='number'
                              fieldProps={{
                                parse: parseNumber,
                              }}
                            />
                          )}
                          {countByValue === 'MONEY_AMOUNT' && (
                            <CurrencyInputField name={thresholdName} label={thresholdLabel} />
                          )}
                        </Grid>
                        <Grid item sm={3}>
                          <Select
                            name={`${fieldArrayName}.countProductsBy`}
                            label='Count By'
                            data={selectData}
                            inputProps={{ onChange: handleSelectChange }}
                            formControlProps={{ size: 'medium', margin: 'none' }}
                          />
                        </Grid>
                        <Grid item sm={5}>
                          <ProductGroupSelectField
                            inputProps={{
                              margin: 'none',
                            }}
                            name={`${fieldArrayName}.eligibleProductGroups`}
                            label='Product groups'
                          />
                        </Grid>
                        <Grid item sm={2}>
                          {isDeleteActionShown && (
                            <IconButton onClick={handleRemoveItem} size='medium' sx={{ mt: 1 }}>
                              <DeleteIcon color='error' fontSize='inherit' />
                            </IconButton>
                          )}
                          {isAddActionShown && (
                            <IconButton
                              disabled={!isEditable}
                              onClick={handleAddItem}
                              size='medium'
                              sx={{ mt: 1 }}
                            >
                              <AddIcon fontSize='inherit' />
                            </IconButton>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </div>
                );
              })}
            </>
          );
        }}
      </FieldArray>
      <Box mt={3}>
        <Radios name='productChallenge.earningMechanism' data={radioData} />
      </Box>
    </Box>
  );
};
